import { render } from "./Order.vue?vue&type=template&id=64139286"
import script from "./Order.vue?vue&type=script&lang=js"
export * from "./Order.vue?vue&type=script&lang=js"
script.render = render

export default script